// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rT9m","rootMobile":"styles_rootMobile__2a_zA"};